module.exports = new __parcel__URL__("tokenpocket.a61039cd.png").toString();